import type { UserModel, UserSecurityInfoModel } from "../../models/user.models";
import { RequestClientService } from "./request-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { ConfigService } from "./config.service";

@autoinject()
export class UserClientService {

    public currentUser: UserModel;

    constructor(private requestClientService: RequestClientService, private configService: ConfigService) { }

    public getMe(): Promise<UserSecurityInfoModel> {
        return this.requestClientService.get<UserSecurityInfoModel>(this.configService.config.urls.rightShipPlatformApiUrl + "/api/v1/me", {});
    }
    
    //Get current user from RightShipQi API
    public async getCurrentUser(): Promise<UserModel> {
        if (this.currentUser) {
            return this.currentUser;
        }
        else {
            try {
                this.currentUser = await this.requestClientService.get<UserModel>(this.configService.config.urls.rightShipPlatformApiUrl + "/api/v1/rightShipQiUser/GetMe", {});
                return this.currentUser;
            }
            catch (e) {
                console.error("Error getting current user", e);
                return null;
            }
        }
    }

    loadXSRFToken(): Promise<any> {
		return this.requestClientService.get<any>(this.configService.config.urls.rightShipPlatformApiUrl + '/api/v1/Auth0/LoadXSRFToken', {});
	}
}